import { Accordion, AccordionSummary } from '@material-ui/core';
import HeaderTabs from 'core/modules/components/tabs/HeaderTabs/HeaderTabs';
import { stripHtml } from 'core/utils/utils';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'ui/atoms/Icon/Icon';
import InputCheckbox from 'ui/atoms/InputCheckbox/InputCheckbox';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';
import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import CheckboxGroup from 'ui/molecules/CheckboxGroup/CheckboxGroup';

function DialogSearchQuestionsCourseItems({ questionFilters, onSelectFilter, t, currentCourseItems }) {
  return (
    <>
      {/* -------- FILTER BY: COURSES ------- */}
      <div className="dialog-search-questions-new__left-subsection dialog-search-questions-new__courses-header">
        <HeaderTabs tabs={[{ id: 'thisCourse', name: t('common:This course') }]} typeView="border" tabActive="thisCourse" />
        <Accordion className="dialog-search-questions-new__left-subsection-accordion" id={'filterCourse'} defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<Icon name="chevron-down" size="xl" />}
            aria-controls="filterCourse-content"
            id="filterCourse-header"
            className={'dialog-search-questions-new__left-subsection-header'}
          >
            <div className="dialog-search-questions-new__left-section-header-left">
              <TextHtml text={currentCourseItems.courseName} />
            </div>
          </AccordionSummary>
          {currentCourseItems?.units?.length > 0 &&
            currentCourseItems?.units.map((unit) => (
              <Accordion className="dialog-search-questions-new__left-subsection-courses" id={unit?.guid} defaultExpanded={false} key={unit?.guid}>
                <AccordionSummary
                  expandIcon={unit.lessons.length > 0 ? <Icon name="chevron-down" size="xl" /> : null}
                  aria-controls={`${unit?.guid}-content`}
                  id={`${unit?.guid}-header`}
                  className={'dialog-search-questions-new__left-subsection-header'}
                >
                  <div className="dialog-search-questions-new__left-courses-items">
                    <InputCheckbox
                      disabled={false}
                      checked={questionFilters.unit.includes(unit.unitGuid)}
                      label={<span className="sr-only">{`${t('common:Select')} ${stripHtml(unit.unitName)}`}</span>}
                      onChange={(e) => onSelectFilter(unit.unitGuid, 'unit', e.target.checked)}
                    />{' '}
                    <TooltipCustom title={stripHtml(unit.unitName)} placement="top">
                      <div className="dialog-search-questions-new__text-tooltip-wrapper">
                        <TextHtml text={unit.unitName} />
                      </div>
                    </TooltipCustom>
                  </div>
                </AccordionSummary>
                <CheckboxGroup isLegendHidden legend={stripHtml(unit.unitName)}>
                  {unit.lessons.map((lesson) => {
                    return (
                      <div className="dialog-search-questions-new__left-courses-children" key={lesson?.guid}>
                        <div className={`dialog-search-questions-new__left-courses-subitems dialog-search-questions-new__left-courses-items--${''}`}>
                          <InputCheckbox
                            disabled={false}
                            checked={questionFilters.lesson.includes(lesson.lessonGuid)}
                            label={<span className="sr-only">{`${t('common:Select')} ${stripHtml(lesson.lessonName)}`}</span>}
                            onChange={(e) => onSelectFilter(lesson.lessonGuid, 'lesson', e.target.checked)}
                          />
                          <TooltipCustom title={stripHtml(lesson.lessonName)} placement="top">
                            <div className="dialog-search-questions-new__text-tooltip-wrapper">
                              <TextHtml text={lesson.lessonName} />
                            </div>
                          </TooltipCustom>
                        </div>
                      </div>
                    );
                  })}
                </CheckboxGroup>
              </Accordion>
            ))}
        </Accordion>
      </div>
    </>
  );
}

DialogSearchQuestionsCourseItems.propTypes = {
  questionFilters: PropTypes.object,
  onSelectFilter: PropTypes.func,
  t: PropTypes.func,
  currentCourseItems: PropTypes.object,
};

export default DialogSearchQuestionsCourseItems;
